import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

interface Message {
  role: 'user' | 'assistant';
  content: string;
}

const API_URL = process.env.REACT_APP_API_URL || 'https://api.flexara.ro';

const ChatAnonim: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const send = async () => {
    if (!input.trim() || loading) return;
    const mesaj = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', content: mesaj }]);
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/chat/anonim`, {
        mesaj,
        istoric: messages
      });
      setMessages(prev => [...prev, { role: 'assistant', content: res.data.reply }]);
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: 'Eroare — încearcă din nou!' }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', background: '#12121f', fontFamily: 'DM Sans, sans-serif' }}>
      {/* Header */}
      <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #1e1e3a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ color: '#fff', margin: 0 }}>🩺 Flexara — Mod anonim</h2>
        <button onClick={() => navigate('/login')} style={{
          padding: '0.5rem 1rem', borderRadius: '8px', border: '1px solid #2a2a4a',
          background: 'transparent', color: '#a0a0c0', cursor: 'pointer', fontSize: '0.85rem'
        }}>Creează cont gratuit →</button>
      </div>

      {/* Banner GDPR */}
      <div style={{
        background: '#1a1a30',
        borderLeft: '3px solid #F39C12',
        borderBottom: '1px solid #1e1e3a',
        padding: '0.6rem 1rem',
      }}>
        <p style={{ color: '#a0a0c0', fontSize: '0.78rem', margin: 0, lineHeight: 1.5 }}>
          Mesajele tale sunt procesate de Anthropic (SUA) pentru generarea răspunsurilor AI.
          Nu introduci date personale sensibile în chat.
          Prin utilizarea chat-ului, ești de acord cu{' '}
          <a href="/confidentialitate" style={{ color: '#F39C12', textDecoration: 'underline' }}>
            Politica de Confidențialitate
          </a>{' '}Flexara.
        </p>
      </div>

      {/* Mesaje */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {messages.length === 0 && (
          <div style={{ textAlign: 'center', color: '#4a4a6a', marginTop: '3rem' }}>
            <p style={{ fontSize: '2rem' }}>👋</p>
            <p style={{ color: '#8080a0' }}>Bună! Sunt Flexara, asistentul tău pentru sănătatea coloanei.</p>
            <p style={{ color: '#6060a0', fontSize: '0.9rem' }}>Descrie-mi problema ta și te ajut!</p>
          </div>
        )}
        {messages.map((msg, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start' }}>
            <div style={{
              maxWidth: '70%', background: msg.role === 'user' ? '#4a4ad8' : '#1a1a30',
              color: '#e0e0f0', padding: '0.75rem 1rem', lineHeight: 1.5,
              borderRadius: msg.role === 'user' ? '16px 16px 4px 16px' : '16px 16px 16px 4px'
            }}>
              {msg.content}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <div style={{ background: '#1a1a30', padding: '0.75rem 1rem', borderRadius: '16px 16px 16px 4px', color: '#6060a0' }}>
              Flexara scrie...
            </div>
          </div>
        )}
      </div>

      {/* Input */}
      <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid #1e1e3a', display: 'flex', gap: '0.75rem' }}>
        <input value={input} onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && send()}
          placeholder="Descrie durerea sau problema ta..."
          style={{
            flex: 1, padding: '0.75rem 1rem', borderRadius: '12px',
            border: '1.5px solid #2a2a4a', background: '#1a1a30',
            color: '#e0e0f0', fontSize: '1rem'
          }} />
        <button onClick={send} disabled={loading} style={{
          padding: '0.75rem 1.5rem', borderRadius: '12px', border: 'none',
          background: '#4a4ad8', color: '#fff', fontWeight: 600,
          cursor: loading ? 'not-allowed' : 'pointer'
        }}>Trimite</button>
      </div>
    </div>
  );
};

export default ChatAnonim;
